import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Login.css";
import { Container } from 'reactstrap';
import GoogleButton from 'react-google-button'

import "./i18n";
import { useTranslation } from "react-i18next";

//import NavBar from './components/content/Navbar';

import classNames from 'classnames';


function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      // maybe trigger a loading screen

      i18n.changeLanguage(i18n.resolvedLanguage);

      return;
    }
   if (user) {
    //alert("Hello! I am an alert box!!");
    navigate("/cctv");
   }
  }, [user, loading]);



  const login = async () => {
    await logout()
    await signInWithGoogle()
  }
  
  const { t, i18n } = useTranslation();

  return (

    

        
       <div >


        <div>

        <h5>{t("you_need")}</h5>

        
        
        <img height="360" width="164"  src='./img/home1.jpg'/>

        <GoogleButton  onClick={login}>
          {t("login")}
           
         </GoogleButton>
        </div>
        
        
       
    
    </div>

  );
}

export {Login};
//export default Login;
//export const LoginContext = React.createContext();